import { SVGProps } from 'react'

const RegisteredOfficeIcon = ({
  fill = 'white',
  width = '48',
  height = '48',
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='8.38062' y='8.38077' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='17.1436' y='8.38089' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='25.9041' y='8.38098' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='8.38062' y='17.143' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='17.1436' y='17.143' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='25.9041' y='17.1432' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='8.38062' y='25.9059' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='17.1436' y='25.9059' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='25.9041' y='25.906' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='8.38062' y='34.6685' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <rect x='17.1436' y='34.6685' width='4.38093' height='4.38093' rx='1.03767' fill={fill} />
      <path d='M32.3816 2.28564C34.5907 2.28571 36.3816 4.07655 36.3816 6.28564V19.2388C36.3817 19.5543 36.6374 19.8101 36.9529 19.8101H41.1443C43.3532 19.8103 45.1443 21.6011 45.1443 23.8101V41.145C45.1441 43.3538 43.3531 45.1448 41.1443 45.145H6.28491C4.07591 45.145 2.28514 43.354 2.28491 41.145V6.28564C2.28491 4.07651 4.07577 2.28564 6.28491 2.28564H32.3816Z' stroke={fill} strokeWidth='3.42857' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M28.095 34.6684L31.5498 37.2596C32.0529 37.6368 32.7696 37.5141 33.1184 36.9909L39.0479 28.0966' stroke={fill} strokeWidth='3.28596' strokeLinecap='round' />
    </svg>
  )
}

export default RegisteredOfficeIcon
